import React, { FC, ReactNode } from 'react'

export interface TagProps {
  backgroundColor?: string
  className?: string
  children: ReactNode
}

const Tag: FC<TagProps> = ({
  backgroundColor = 'bg-gray-100',
  className = '',
  children
}) => {
  return (
    <div
      className={`inline-block rounded-md px-2 py-[3px] text-xs text-gray-1000 ${backgroundColor} ${className}`}
    >
      {children}
    </div>
  )
}

export default Tag
